/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.scss in this case)

import './styles/style.sass';

import {createApp} from 'vue';
import {components, mixins} from "./scripts/app/mixin";

const consentOptions = {}

export const app = createApp({
    delimiters: ['${', '}'],
})

for (const mixin of mixins) {
    app.mixin(mixin);
}

for (const component of components) {
    app.component(component.name, component.component);
}

app.mount('#__layout');